import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import moment from 'moment';
import ShiftHoursRenderer from 'timeSheet/components/CellRenderers/ShiftHoursRenderer';

const useShiftTimeColumn = () => {
  const { t, timeFormat } = useContext(ConfigContext);

  const valueGetter = useCallback(
    (params) => (params.data?.scheduleIn ? moment(params.data.scheduleIn).format(timeFormat) : null),
    [timeFormat]
  );

  const cellRenderer = useCallback((params) => {
    if (params.node?.group) return null;

    return ShiftHoursRenderer({
      rowData: params.data
    });
  }, []);

  return useMemo(
    () => ({
      field: 'shiftTime',
      headerName: t('shiftTime'),
      initialHide: true,
      valueGetter,
      cellClass: 'justify-start',
      width: 200,
      cellRenderer
    }),
    [t, valueGetter, cellRenderer]
  );
};

export default useShiftTimeColumn;
